import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

// import { User } from "@/@types";

const { persistAtom } = recoilPersist({
  key: 'recoil-persist',
  storage: sessionStorage,
});

export interface UserType {
  isAuth: boolean;
  id?: number;
  token?: string;
  role_name?: string;
  email?: string;
  advertiser_id?: number;
  category?: string,
  //   name: string;
  //   role: UserRole;
}

export const userAtom = atom<UserType | null>({
  key: 'user',
  default: {
    isAuth: false,
    role_name: '',
  },
  effects_UNSTABLE: [persistAtom],
});
